import { getPaginationRowModel, SortingState } from "@tanstack/react-table"
import type { Invoice } from "@tfg/db"
import { DEFAULT_PAGE_SIZE } from "@tfg/ui"
import { useState } from "react"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import { CustomTable } from "~/components/table/CustomTable"
import { useColumns } from "~/pages/Brand/Invoices/columns.tsx"

type Props = {
  orgName: string
  invoices: Invoice[]
}
export const InvoicesTable = ({ invoices, orgName }: Props) => {
  const columns = useColumns(orgName)

  const [sorting, setSorting] = useState<SortingState>([
    { id: "issueDate", desc: true },
  ])

  const table = useCustomReactTable({
    data: invoices,
    columns,
    initialState: {
      pagination: {
        pageSize: DEFAULT_PAGE_SIZE,
      },
    },
    state: {
      sorting,
    },
    onSortingChange: setSorting,

    getPaginationRowModel: getPaginationRowModel(),
  })

  return <CustomTable table={table} />
}
